<template>
  <div v-if="content.length !== 0"
       style="position: relative"
  >
    <div class="rich-text-component"
         :class="{ 'show-padding': showPadding }"
         :style="style"
         v-html="content"
    ></div>
    <template v-if="rule">
      <div v-for="(item,index) in percentGrainList"
           :key="index"
           class="rich-text-rule"
           :style="`top: ${item.height}px`"
      >{{ item.limit }}%</div>
    </template>
  </div>
</template>

<script>
  import richTextMixin from '@/mixins/dom/rich-text';
  import { addUnit } from '@/utils';

  export default {
    name: 'YmRichText',
    mixins: [richTextMixin],
    props: {
      content: {
        type: String,
        default: '',
        required: true,
      },
      showPadding: {
        type: Boolean,
        default: false,
      },
      minHeight: [String, Number],
      percentGrainList: Array,
    },
    computed: {
      style() {
        const style = {};
        const { minHeight } = this;
        if (minHeight) {
          style.minHeight = `${addUnit(minHeight)}`;
        }
        return style;
      },
      rule() {
        return this.$route.query.rule;
      },
    },
    watch: {
      content() {
        // 设置DOM 元素特性
        this.mixinSetupRichTextElement();
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .rich-text-component {
    box-sizing: border-box;
    line-height: 1.4;
    font-size: @font-size-base;
    word-break: break-word;
    overflow-x: hidden;

    /deep/ p {
      margin: 0;
    }
    /deep/ img, /deep/ iframe {
      display: block;
      width: 100%;
    }
    /deep/ video {
      display: block;
      width: 100%;
      height: calc((100% * 9) / 16);
      object-fit: fill;
    }
    /deep/ table {
      width: 100%;
    }
    &.show-padding {
      padding: 0 @size-base;
    }
  }

  .rich-text-rule {
    position: absolute;
    left: 0;
    z-index: 9;
    padding: 0 10px;
    color: #fff;
    background-color: @color-primary;
    border-radius: 0 10px 10px 0;
  }
</style>
